import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';

export default WithApp(function ModalReplace(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [Supervisor, setSupervisor] = useState([]);

  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listSupervisores() {
    let response = await wsFindBy('base/supervisor', { state: 'A', deleted: null });
    if (response.success) setSupervisor(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (bPartnerSelect?.base_business_partner_id) {
      setDataChanging((prev) => ({
        ...prev,
      }));
    }
  }, [bPartnerSelect]);

  
  useEffect(() => {
      if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) listSupervisores();
      setDataChanging(customerPortfolioB);
      }
  }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Reemplazar supervisor`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={'sale/replace-supervisors'}
        dataForce={{
                    base_supervisor_id_old: dataChanging.base_supervisor_id_old,
                    base_supervisor_id_new: dataChanging.base_supervisor_id_new,
                  }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={Supervisor}
          getOptionLabel={(item) => `${item.name}`}
          renderInput={(params) => (
            <TextField {...params} label="Supervisor de origen" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('base_supervisor_id_old', item?.id);}}
          value={Supervisor.find((supervisor) => supervisor.id === dataChanging.base_supervisor_id_old) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={Supervisor}
          getOptionLabel={(item) => `${item.name}`}
          renderInput={(params) => (
            <TextField {...params} label="Supervisor a reemplazar" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('base_supervisor_id_new', item?.id);}}
          value={Supervisor.find((supervisor) => supervisor.id === dataChanging.base_supervisor_id_new) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
      </Modal>
    </>
  );
});
